export default __webpack_public_path__ + "static/media/bra-arte-7.98160e76.webp";